import api from '../services/api';

const API_URL = '/sales/';

export const createSale = async (saleData, localItems = []) => {
  const response = await api.post(`${API_URL}create_sale/`, saleData);
  if (response?.data?.queued) {
    const items = localItems.map((item, index) => {
      const priceUSD = item.currency === 'USD' ? Number(item.selling_price || 0) : 0;
      const priceLBP = item.currency === 'LBP' ? Number(item.selling_price || 0) : 0;
      const multiplier = item.isWholeBox ? Number(item.boxCount || 0) : Number(item.cartQuantity || 0);
      const subtotalUSD = priceUSD * multiplier;
      const subtotalLBP = priceLBP * multiplier;
      return {
        id: `offline-${Date.now()}-${index}`,
        item_name: item.name,
        quantity: item.isWholeBox ? Number(item.boxCount || 0) : Number(item.cartQuantity || 0),
        price_usd: priceUSD,
        price_lbp: priceLBP,
        subtotal_usd: subtotalUSD,
        subtotal_lbp: subtotalLBP,
        exchange_rate: item.exchange_rate || 1,
      };
    });

    const total_usd = items.reduce((sum, i) => sum + (i.subtotal_usd || 0), 0);
    const total_lbp = items.reduce((sum, i) => sum + (i.subtotal_lbp || 0), 0);

    return {
      id: `offline-${Date.now()}`,
      receipt_number: `offline-${Date.now()}`,
      sale_date: saleData.client_sale_date || new Date().toISOString(),
      payment_method: saleData.payment_method,
      notes: saleData.notes || '',
      total_usd,
      total_lbp,
      items,
      offline: true,
    };
  }
  return response.data;
};

export const getSales = async () => {
  const response = await api.get(API_URL);
  return response.data;
};

export const getSale = async (id) => {
  const response = await api.get(`${API_URL}${id}/`);
  return response.data;
};

export const getProfitReport = async (
  startDate = null,
  endDate = null,
  saleType = 'all',
  paymentFilter = 'all',
  invoiceFilter = 'all'
) => {
  let url = `${API_URL}profit_report/`;
  const params = new URLSearchParams();
  
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  if (saleType && saleType !== 'all') params.append('sale_type', saleType);
  if (paymentFilter && paymentFilter !== 'all') params.append('payment_filter', paymentFilter);
  if (invoiceFilter && invoiceFilter !== 'all') params.append('invoice_filter', invoiceFilter);
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  const response = await api.get(url);
  return response.data;
};

export const getSalesChart = async (
  startDate = null,
  endDate = null,
  saleType = 'all',
  paymentFilter = 'all',
  invoiceFilter = 'all'
) => {
  let url = `${API_URL}sales_chart/`;
  const params = new URLSearchParams();
  
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  if (saleType && saleType !== 'all') params.append('sale_type', saleType);
  if (paymentFilter && paymentFilter !== 'all') params.append('payment_filter', paymentFilter);
  if (invoiceFilter && invoiceFilter !== 'all') params.append('invoice_filter', invoiceFilter);
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  const response = await api.get(url);
  return response.data;
};
